<lib-form-header-checkout title="お支払い">
  <lib-accordeon
    [value]="type$ | async"
    (valueChange)="setType($event)"
  >
    <!-- クレジットカード
        <div style="position: relative">
          <svg-icon
            class="ssl-icon"
            src="assets/images/icons/order-main-payment-ssl.svg"
            (mouseenter)="tooltipCartNumber.show()"
            (mouseleave)="tooltipCartNumber.hide()"
          ></svg-icon>
          <lib-tooltip #tooltipCartNumber
            >すべての取引は暗号化されており安全にご購入いただけます。</lib-tooltip
          >
        </div> -->
    <lib-accordeon-item
      [value]="EFormPaymentType.card"
      [imgSrc]="
        (mediaService.isLtSm$ | async)
          ? 'assets/images/cart-payments-mobile.png'
          : 'assets/images/cart-payments.png'
      "
      [imgSrc2]="
        (mediaService.isLtSm$ | async)
          ? 'assets/images/konbini-payments-mobile.png'
          : 'assets/images/konbini-payments.png'
      "
    >
      <lib-accordeon-item-header>
        クレジットカー<br
          *ngIf="mediaService.isLtMd$ | async"
        />ドまたはコンビニ払い
        <div style="position: relative">
          <svg-icon
            class="ssl-icon"
            src="assets/images/icons/order-main-payment-ssl.svg"
            (mouseenter)="tooltipCartNumber.show()"
            (mouseleave)="tooltipCartNumber.hide()"
          ></svg-icon>
          <lib-tooltip #tooltipCartNumber
            >すべての取引は暗号化されており安全にご購入いただけます。</lib-tooltip
          >
        </div>
      </lib-accordeon-item-header>
      <lib-accordeon-item-content>
        <form class="card">
          <div class="card__section">
            <app-konbini-item
              >決済時に3Dセキュア（本人認証サービス）を求められた場合は、認証まで完了してください。</app-konbini-item
            >
            <app-konbini-item
              >コンビニ払いはお支払い完了をもってご注文完了となります。<b
                >お支払いが遅くなると、その分商品の到着も遅くなりますのでご注意ください。</b
              ></app-konbini-item
            >
          </div>
          <div class="card__section card__section_footer">
            <ng-template #cardButtonNameTpl
              >支払いに進む
              <br />
              <small>（別の画面が開きます）</small></ng-template
            >
            <ng-container
              *ngTemplateOutlet="
                footer;
                context: { buttonNameTpl: cardButtonNameTpl }
              "
            ></ng-container>
          </div>
        </form>
      </lib-accordeon-item-content>
    </lib-accordeon-item>
  </lib-accordeon>
</lib-form-header-checkout>

<ng-template
  #footer
  let-buttonNameTpl="buttonNameTpl"
>
  <div class="footer">
    <div
      class="footer__text"
      *ngIf="footerDescription"
      [innerHTML]="footerDescription | safe: 'html'"
    ></div>
    <lib-button
      class="footer__button"
      [disabled]="submitButtonDisabled"
      (buttonClick)="submitButtonClick.emit()"
      [fullWidth]="true"
    >
      <ng-container *ngTemplateOutlet="buttonNameTpl"></ng-container>
    </lib-button>
    <p class="footer__text">
      お支払いを完了すると<a
        routerLink="/terms"
        target="_blank"
        >利用規約</a
      >に同意したことになります
    </p>
  </div>
</ng-template>
